import { Environment, Lightformer } from "@react-three/drei";

/**
 * Procedural studio-lighting rig — soft rectangular "softbox" reflections
 * for the car's paint, chrome, and glass, baked into a cubemap at runtime
 * from these light shapes. No external HDRI file, no network dependency —
 * just three.js primitives, which keeps the scene self-contained and fast
 * to first paint.
 */
export function StudioEnvironment() {
  return (
    <Environment resolution={512} frames={1} background={false} environmentIntensity={1}>
      {/* Broad, dim ambient fill enclosing the whole rig */}
      <Lightformer form="rect" intensity={0.6} color="#f1eefb" position={[0, 3, 8]} scale={[30, 20, 1]} target={[0, 0.6, 0]} />
      <Lightformer form="rect" intensity={0.5} color="#eee9fb" position={[0, 3, -8]} scale={[30, 20, 1]} target={[0, 0.6, 0]} />

      {/* Large soft key light, front-top */}
      <Lightformer form="rect" intensity={2.4} color="#ffffff" position={[0, 6, 5]} scale={[9, 4, 1]} target={[0, 0.6, 0]} />
      {/* Cooler fill from the opposite side */}
      <Lightformer form="rect" intensity={1.1} color="#dee6ff" position={[-7, 3, -1]} scale={[6, 3, 1]} target={[0, 0.6, 0]} />
      {/* Subtle brand-violet rim light from behind */}
      <Lightformer form="rect" intensity={2.8} color="#8a6bff" position={[3.5, 3.5, -6.5]} scale={[5, 3, 1]} target={[0, 0.6, 0]} />
      {/* Warm accent kissing the opposite rim */}
      <Lightformer form="rect" intensity={1.4} color="#ffd9a0" position={[-3.5, 2, -6]} scale={[4, 2.5, 1]} target={[0, 0.6, 0]} />
      {/* Soft ground bounce beneath the car */}
      <Lightformer form="ring" intensity={0.7} color="#ffffff" position={[0, -1.5, 0]} scale={9} rotation={[Math.PI / 2, 0, 0]} />
    </Environment>
  );
}
